<template>
  <div>
<el-cascader
    v-model="value"
    :disabled="disabled"
    :options="dicData"
    @change="handleChange"
    :placeholder="placeholder"></el-cascader>
  </div>
</template>

<script>
import mixinRemoteDic from './mixins/remoteDic'
export default {
  props: ['column', 'scope'],
  mixins: [mixinRemoteDic],
  data() {
    const {
      dicData,
      disabled,
      label
    } = this.column
    return {
      disabled: !!disabled,
      placeholder: disabled ? '' : `请选择${label}`,
      dicData,
      value: this.scope.row[this.column.prop]
    }
  },
  watch: {
    scope({ row }) {
      this.value = row[this.column.prop]
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('on-edit', value, this.column.prop, this.scope.$index)
    }
  }
}
</script>
